export const CHILD_PREFIX = 'auth'
const idDev = process.env.NODE_ENV === 'development'

export const MICRO_APPS = [
  {
    name: 'authCommon',
    url: idDev
      ? 'http://ikg.dev.healthprime.cn/auth'
      : `${window.location.origin}/auth`,
  },
]

export const BASE_ROUTE = {
  login: '/login',
  userList: '/user',
  roleList: '/role',
  agreement: '/agreement',
  privacyPolicy: '/privacyPolicy',
}

export default {}
